module.exports = "<app-top-nav-bar></app-top-nav-bar>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"